import { drawColorBars } from '@/threejs/utils/canvasPatterns';
import type { InputSource } from './types';

export const colorbars: InputSource = {
  label: 'Color Bars',
  value: 'colorbars',
  draw: (ctx, width, height) => {
    drawColorBars(ctx, width, height);
  },
};
